<template>
    <div class="dashboard-container">
        <!-- Sidebar -->
        <nav class="sidebar shadow-sm">
            <div class="sidebar-header p-4">
                <h4 class="font-weight-bold text-primary mb-0">ໂຄງການອາຫານທ່ຽງ</h4>
                <small class="text-muted">ລະບົບຈັດການຂໍ້ມູນ</small>
            </div>

            <div class="menu-wrapper px-3">
                <div v-for="menu in menus" :key="menu.menuid" class="mb-2">
                    <div v-if="menu.login">
                        <b-button v-b-toggle="menu.menuid" variant="link" class="menu-parent-btn d-flex justify-content-between align-items-center w-100 text-decoration-none py-2 px-3">
                            <span>
                                <b-icon :icon="menu.icon" class="mr-2"></b-icon>
                                {{ menu.menudesc_lao }}
                            </span>
                            <b-icon icon="chevron-down" font-scale="0.8" class="when-opened"></b-icon>
                            <b-icon icon="chevron-right" font-scale="0.8" class="when-closed"></b-icon>
                        </b-button>

                        <b-collapse :id="menu.menuid" accordion="sidebar-menu" class="mt-1">
                            <div class="submenu-list">
                                <router-link 
                                    v-for="smenu in menu.submenu" 
                                    :key="smenu.menuid"
                                    v-show="smenu.login"
                                    :to="smenu.link + '?id=' + smenu.menuid + '&desc=' + smenu.menudesc_lao"
                                    class="submenu-item d-block py-2 pl-4 text-decoration-none"
                                    active-class="active"
                                >
                                    <b-icon :icon="smenu.icon" class="mr-2" font-scale="0.9"></b-icon>
                                    {{ smenu.menudesc_lao }}
                                </router-link>
                            </div>
                        </b-collapse>
                    </div>
                </div>
            </div>

            <div class="sidebar-footer p-3 border-top mt-auto">
                <div class="d-flex align-items-center mb-3">
                    <b-avatar variant="primary" class="mr-2"></b-avatar>
                    <div class="user-info overflow-hidden">
                        <div class="font-weight-bold text-truncate text-dark">{{ user.username }}</div>
                        <small class="text-muted">ຜູ້ໃຊ້ງານລະບົບ</small>
                    </div>
                </div>
                <b-button variant="outline-danger" block size="sm" @click="exit" class="rounded-pill">
                    <b-icon icon="power" class="mr-1"></b-icon> ອອກຈາກລະບົບ
                </b-button>
            </div>
        </nav>

        <!-- Main Content -->
        <main class="main-content">
            <!-- Welcome Dashboard (Visible only on Home route) -->
            <div v-if="$route.path === '/'" class="p-4">
                <header class="mb-4">
                    <h2 class="font-weight-bold">ພາບລວມລະບົບ</h2>
                    <p class="text-muted">ຂໍ້ມູນສະຫຼຸບລາຍຮັບ-ລາຍຈ່າຍ ຂອງໂຄງການ ປະຈຳສົກຮຽນ {{ currentAccd }}.</p>
                </header>

                <div v-for="item in summarys" :key="item.source_type" class="mb-4">
                    <b-row>
                        <b-col md="12" class="mb-3">
                            <div class="source-label">
                                <b-icon icon="bookmark-fill" class="mr-2"></b-icon>
                                ແຫຼ່ງທຶນ: <strong>{{ item.source_type }}</strong>
                            </div>
                        </b-col>
                        <b-col md="4">
                            <b-card border-variant="light" class="shadow-sm stat-card border-left-primary">
                                <div class="d-flex align-items-center">
                                    <div class="icon-box bg-light-primary text-primary mr-3">
                                        <b-icon icon="graph-up" font-scale="1.5"></b-icon>
                                    </div>
                                    <div>
                                        <div class="text-muted small">ລາຍຮັບທັງໝົດ</div>
                                        <div class="h4 mb-0 font-weight-bold text-primary">{{ format(item.total_income) }}</div>
                                    </div>
                                </div>
                            </b-card>
                        </b-col>
                        <b-col md="4">
                            <b-card border-variant="light" class="shadow-sm stat-card border-left-danger">
                                <div class="d-flex align-items-center">
                                    <div class="icon-box bg-light-danger text-danger mr-3">
                                        <b-icon icon="graph-down" font-scale="1.5"></b-icon>
                                    </div>
                                    <div>
                                        <div class="text-muted small">ລາຍຈ່າຍທັງໝົດ</div>
                                        <div class="h4 mb-0 font-weight-bold text-danger">{{ format(item.total_expense) }}</div>
                                    </div>
                                </div>
                            </b-card>
                        </b-col>
                        <b-col md="4">
                            <b-card border-variant="light" class="shadow-sm stat-card border-left-success">
                                <div class="d-flex align-items-center">
                                    <div class="icon-box bg-light-success text-success mr-3">
                                        <b-icon icon="wallet2" font-scale="1.5"></b-icon>
                                    </div>
                                    <div>
                                        <div class="text-muted small">ຍອດເຫຼືອຕົວຈິງ</div>
                                        <div class="h4 mb-0 font-weight-bold text-success">{{ format(item.total_income - item.total_expense) }}</div>
                                    </div>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>
                </div>

                <!-- District Chart Section -->
                <b-row class="mt-2">
                    <b-col cols="12">
                        <b-card title="ສະຖິຕິລາຍຮັບ-ລາຍຈ່າຍ ແຍກຕາມເມືອງ ແລະ ແຫຼ່ງທຶນ" class="shadow-sm border-0">
                            <apexchart 
                                type="bar" 
                                height="350" 
                                :options="districtChartOptions" 
                                :series="districtChartSeries"
                            >
                            </apexchart>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
           
            <!-- Router View for Sub-pages -->
            <div class="router-content">
                <router-view />
            </div>
        </main>
    </div>
</template>

<script>
import axios from "axios";
export default {
    name: "Home",
    data() {
        return {
            user:[],
            menus: [],
            submenu: [],
            summarys: [],
            summary: {
                income: 0,
                expense: 0
            },
            districtChartSeries: [],
            districtChartOptions: {
                chart: {
                    fontFamily: 'Noto Sans Lao Regular, sans-serif',
                    toolbar: { show: false }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '60%',
                        borderRadius: 4
                    },
                },
                dataLabels: { enabled: false },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: { categories: [] },
                fill: { opacity: 1 },
                legend: { position: 'top' },
                tooltip: {
                    y: {
                        formatter: (val) => this.format(val) + " ກີບ"
                    }
                }
            },
            // ສີຄູ່ (ລາຍຮັບ, ລາຍຈ່າຍ) ຕໍ່ 1 ແຫຼ່ງທຶນ
            sourceTypeColors: [
                ['#007bff', '#dc3545'],
                ['#28a745', '#fd7e14'],
                ['#6f42c1', '#e83e8c'],
                ['#17a2b8', '#ffc107'],
            ]
        };
    },
    computed: {
        currentAccd() {
            const now = new Date();
            const year = now.getFullYear();
            const month = now.getMonth() + 1; // ເດືອນໃນ JS ເລີ່ມຈາກ 0-11
            // ຖ້າເດືອນ >= 9 (ກັນຍາ) ໃຫ້ຖືວ່າເປັນສົກປີໃໝ່
            return month >= 9 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
        }
    },
    mounted() {
        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);

        this.fetchSummary();
        this.fetchDistrictSummary();

         axios.get(this.$store.getters.getBaseUrl + "/getMenu/0000?"+"level_id="+this.user.user_level,
         {
            headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
         }
         ).then((rep) => {
             this.menus = rep.data;
         });
    },
    methods: {
        exit() {
            localStorage.removeItem("Login");
            this.$router.push("/login");
        },
        fetchSummary() {
            axios.get(this.$store.getters.getBaseUrl + "/dashboard_summary", {
                params: {
                    accd: this.currentAccd,
                    prov_id: this.user.prov_id,
                    org_type_code: this.user.org_type_code
                },
                headers: { 'Authorization': 'Bearer ' + this.user.login_hash }
            })
            .then((res) => {
                if (res.data) {
                    this.summarys = res.data;
                    this.summary.income = res.data.total_income || 0;
                    this.summary.expense = res.data.total_expense || 0;
                }
            })
            .catch(err => {
                console.error("Error fetching summary:", err);
            });
        },
        fetchDistrictSummary() {
            axios.get(this.$store.getters.getBaseUrl + "/dashboard_district_summary", {
                params: {
                    prov_id: this.user.prov_id,
                    org_type_code: this.user.org_type_code,
                    accd: this.currentAccd
                },
                headers: { 'Authorization': 'Bearer ' + this.user.login_hash }
            })
            .then((res) => {
                const data = res.data || [];

                // ດຶງລາຍຊື່ເມືອງ ແລະ ແຫຼ່ງທຶນ ທີ່ unique
                const districts = [...new Set(data.map(d => d.district_name).filter(Boolean))];
                const sourceTypes = [...new Set(data.map(d => d.source_type).filter(Boolean))].sort();

                // Build colors ຕາມຈຳນວນ source_type
                const allColors = [];
                const series = [];
                sourceTypes.forEach((st, i) => {
                    const pair = this.sourceTypeColors[i % this.sourceTypeColors.length];
                    allColors.push(pair[0], pair[1]);
                    series.push({
                        name: `ລາຍຮັບ (${st})`,
                        data: districts.map(d => {
                            const row = data.find(x => x.district_name === d && x.source_type === st);
                            return row ? row.income : 0;
                        })
                    });
                    series.push({
                        name: `ລາຍຈ່າຍ (${st})`,
                        data: districts.map(d => {
                            const row = data.find(x => x.district_name === d && x.source_type === st);
                            return row ? row.expense : 0;
                        })
                    });
                });

                this.districtChartOptions = {
                    ...this.districtChartOptions,
                    xaxis: { categories: districts },
                    colors: allColors
                };
                this.districtChartSeries = series;
            })
            .catch(err => console.error(err));
        },
        
        format(number) {
            return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(number);
        }

    },
};
</script>

<style scoped>
.dashboard-container {
    display: flex;
    min-height: 100vh;
    background-color: #f4f7f6;
}

/* Sidebar Styles */
.sidebar {
    width: 280px;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    position: fixed;
    height: 100vh;
    z-index: 1000;
}

.main-content {
    flex: 1;
    margin-left: 280px;
    padding: 20px;
}

.menu-parent-btn {
    color: #495057;
    font-weight: 600;
    border-radius: 10px;
    transition: all 0.2s;
}

.menu-parent-btn:hover {
    background-color: #f8f9fa;
    color: #007bff;
}

.submenu-item {
    color: #6c757d;
    font-size: 0.95rem;
    border-radius: 8px;
    margin-bottom: 2px;
    transition: all 0.2s;
}

.submenu-item:hover, .submenu-item.active {
    background-color: #e7f1ff;
    color: #007bff;
    font-weight: 500;
}

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
    display: none;
}

/* Content & Cards */
.stat-card {
    border-radius: 15px;
    transition: transform 0.2s;
}

.stat-card:hover {
    transform: translateY(-5px);
}

.border-left-primary { border-left: 5px solid #007bff !important; }
.border-left-danger { border-left: 5px solid #dc3545 !important; }
.border-left-success { border-left: 5px solid #28a745 !important; }

.icon-box {
    width: 50px;
    height: 50px;
    border-radius: 12px;
    min-width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.bg-light-primary { background-color: #e7f1ff; }
.bg-light-success { background-color: #d4edda; }
.bg-light-danger { background-color: #f8d7da; }

.source-label {
    font-size: 1rem;
    font-weight: 600;
    color: #495057;
    padding: 8px 14px;
    background: #f0f4ff;
    border-left: 4px solid #007bff;
    border-radius: 6px;
}

@media (max-width: 768px) {
    .sidebar { width: 100%; position: relative; height: auto; }
    .main-content { margin-left: 0; }
    .dashboard-container { flex-direction: column; }
}
</style>